module.exports = function (app, mod, theme_options, selected_theme) {
  console.log(theme_options, selected_theme);
  var options = "";
  for (var theme in theme_options) {
    options += "\n          <div id=\"user_menu_item_".concat(theme, "\" data-theme=\"").concat(theme, "\" class=\"saito-modal-menu-option\">\n            <i class=\"").concat(theme_options[theme], "\"></i>\n            <div>").concat(theme.toUpperCase(), " ").concat(theme == selected_theme ? "<i class=\"fa-solid fa-check\"></i>" : "", "</div>\n          </div>");
  }
  var html = "\n    <div class=\"saito-modal saito-modal-menu\" id=\"saito-them-menu\">\n      <div class=\"saito-modal-content saito-menu-select-heavy\">\n          ".concat(options, "\n      </div>\n   </div>\n  ");
  return html;
};